import React from 'react';

const Portfolio: React.FC = () => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="win-card p-6">
        <h1 className="text-3xl font-bold text-win-dark-text">Portfolio</h1>
        <p className="text-win-dark-text-muted">Track your gold trading performance and holdings</p>
      </div>
      {/* Portfolio content will be implemented */}
    </div>
  );
};

export default Portfolio;